module.exports = __webpack_public_path__ + "static/media/galerija_2021 (3)-min.fdf60aa7.jpg";